module.exports = __webpack_public_path__ + "static/media/TAOD2.a1bddee9.jpg";